export const sum = (array) => {
    return array.reduce((partialSum, a) => {
        return partialSum + (((typeof Number.parseFloat(a) === 'number') && !Number.isNaN(Number.parseFloat(a))) ? Number.parseFloat(a) : 0)
    }, 0)
}

export const cargoPackagesCount = (form) => {
    return sum(((form || {}).positions || []).map(p => p.cargoPackages));
};

export const calcVolume = place => {
    let clc = ((place.length * place.height * place.width) / 1000000).toFixed(7);
    return isNaN(clc) ? 0 : clc;
}

export const calcVolumesSum = form => {
    return sum(((form || {}).positions || []).map(p => calcVolume(p)* p.cargoPackages));
}

export const calcWeightSum = form => {
    // Используем точное вычисление с округлением для избежания проблем с плавающей запятой
    return ((form || {}).positions || []).reduce((total, p) => {
        const weight = Number.parseFloat(p.weight) || 0;
        const packages = Number.parseFloat(p.cargoPackages) || 0;
        // Умножаем и округляем до 9 знаков после запятой для точности
        const product = Math.round((weight * packages) * 1000000000) / 1000000000;
        return total + product;
    }, 0);
}

export const volumeToWeight = (form) => {
  return form.cargoVolume ? (form.cargoVolume * 1000000) / 5000 : 0
}

export const calcWeight = (form) => {
    let num = 0;

    form.positions && form.positions.forEach(p => {
        num = num + ((((p.length || 0) * (p.width || 0) * (p.height || 0)) / 5000) * (p.cargoPackages || p.packagesCount || 1));
    });

    return Math.round(num * 2 / 2);
}

export const totalWeight = (form, calcByPlacesOn) => {
    const byPlacesOn = calcByPlacesOn !== undefined
        ? calcByPlacesOn
        : ((form || {}).positions || []).length;
    const formWeight = form.cargoWeight;
    const calcWeightValue = byPlacesOn
        ? calcWeight(form)
        : volumeToWeight(form);
    return formWeight > calcWeightValue ? formWeight : calcWeightValue;

}

export const changeValues = (form, name, value, changeParam, isAll) => {
    if (name === 'weight' || isAll) changeParam('cargoWeight', calcWeightSum(form));
    if (name === 'cargoPackages' || isAll) changeParam('cargoPackages', cargoPackagesCount(form));
    const names = ['length', 'width', 'height'];
    const valuesIsValid = (form || {}).positions.find(p => names.every(n => p[n]));
    if (isAll || (names.includes(name) && valuesIsValid)) changeParam('cargoVolume', calcVolumesSum(form));
}


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/math.js